import * as types from "@/store/coupon/types";
import {
  couponCodeList,
  createCoupon,
  editCouponcode,
  deleteCouponcode,
  approveCouponcode,
  listPromotionByFilter,
} from "@/services/coupon";

export default {
  async createCoupon({ commit }, payload) {
    try {
      const data = await createCoupon(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async couponCodeList({ commit }, userType) {
    try {
      let URL = userType === "Tenant" ? "tenant/all" : "provider/all";
      const data = await couponCodeList(URL);
      commit(types.SET_COUPONCODELIST, data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  },

  async editCouponcode({ commit }, payload) {
    try {
      const data = await editCouponcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async setCouponObject({ commit }, payload) {
    try {
      commit(types.SET_COUPONOBJECT, payload);
      return payload;
    } catch (error) {
      throw error;
    }
  },

  async deleteCouponcode({ commit }, payload) {
    try {
      const data = await deleteCouponcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },
  async approveCouponcode({ commit }, payload) {
    try {
      const data = await approveCouponcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },
  async promotionListByFilter({ commit },payload){
    try {
      const data = await listPromotionByFilter(payload);
      commit(types.SET_COUPONCODELIST,data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }
};
